<template>
  <div class="data-discuss" @click="changeVisible">
    <div v-ps class="discuss-list">
      <div
        class="discuss-content"
        ref="discuss"
        v-for="(discuss, index) in discussList"
        :key="index"
      >
        <div class="member-avatar">
          <staff-popover :staffId="discuss.sender.id">
            <template v-slot:reference>
              <staff-avatar class="avatar" :size="30" :user="discuss.sender"></staff-avatar>
            </template>
          </staff-popover>
        </div>
        <div class="message-content">
          <div class="basic-info">
            <div class="info">
              <span class="sender-name">{{ discuss.sender.name }}</span>
              <span class="time">{{ discuss.time.slice(5) }}</span>
            </div>
            <div class="operation">
              <dropdown-menu
                :menu-list="curUser.userId === discuss.sender.id ? operations : operations.slice(1)"
                @click="handleCommand($event, discuss)"
                placement="bottom-end"
                from="detailDialog"
                width="100"
                style="margin-left: 10px;"
              >
                <span class="pointer">
                  <i class="el-icon-more icon-color"></i>
                </span>
              </dropdown-menu>
            </div>
          </div>
          <div class="message-main">
            <div v-if="!_.isEmpty(discuss.quote)" class="other">
              <span class="other-name">{{ discuss.quote.sender.name + "：" }}</span>
              <span class="other-message">
                <span v-for="(item, index) in discuss.quote.contentList" :key="index">
                  <span v-if="item.type === 'common'">{{ item.text }}</span>
                  <span v-else>
                    <staff-popover :staffId="item.id">
                      <template v-slot:reference>
                        <span style="color: #1989FA; margin: 0 4px">{{ "@" + item.name }}</span>
                      </template>
                    </staff-popover>
                  </span>
                </span>
              </span>
            </div>
            <div class="message">
              <span v-for="(item, index) in discuss.contentList" :key="index">
                <span v-if="item.type === 'common'">{{ item.text }}</span>
                <span v-else>
                  <staff-popover :staffId="item.id">
                    <template v-slot:reference>
                      <span style="color: #1989FA; margin: 0 4px">{{ "@" + item.name }}</span>
                    </template>
                  </staff-popover>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reply-area">
      <div class="message-area" @click="setFocus" v-ps>
        <div class="other" v-if="!_.isEmpty(discuss.quote)">
          <el-divider direction="vertical"></el-divider>
          {{ discuss.quote.name + "：" }}
          <span v-for="(item, index) in discuss.quote.contentList" :key="index">
            <span v-if="item.type === 'common'">{{ item.text }}</span>
            <span v-else>
              <staff-popover :staffId="item.id">
                <template v-slot:reference>
                  <span style="color: #1989FA; margin: 0 4px">{{ "@" + item.name }}</span>
                </template>
              </staff-popover>
            </span>
          </span>
          <span class="clear-reply">
            <el-tooltip class="item" effect="dark" content="清除回复" placement="right">
              <i class="el-icon-circle-close pointer" @click="clearReply"></i>
            </el-tooltip>
          </span>
        </div>
        <select-staff-popover
          ref="selectStaffPopper"
          :visible="staffVisible"
          :users="filterUsers"
          @liftUser="liftUser"
        >
          <template v-slot:reference>
            <el-input
              id="textarea"
              type="textarea"
              resize="none"
              autosize
              :placeholder="'@提及他人 按' + sendType + '发送'"
              v-model="discuss.contentInfo"
              @input="showStaffPopover"
              @focus="focus"
              @blur="blur"
            ></el-input>
          </template>
        </select-staff-popover>
      </div>
      <div class="operation-area">
        <select-emoji-popper :visible="emojiVisible" @setLook="setLook">
          <template v-slot:reference>
            <div @click.stop="selectLook">
              <svg-icon
                icon-class="detail_look"
                class="pointer icon-color"
                style="font-size: 18px"
              ></svg-icon>
            </div>
          </template>
        </select-emoji-popper>
        <div class="send-type">
          <base-button @click="sendMessage" type="text">
            发送
          </base-button>
          <dropdown-menu
            :menu-list="sendTypes"
            @click="handleSendCommand($event)"
            placement="top-end"
            from="detailDialog"
            width="160"
            style="margin-left: 2px"
          >
            <span class="pointer">
              <svg-icon
                icon-class="detail_menu-open"
                class-name="icon-color"
                style="font-size: 18px"
              ></svg-icon>
            </span>
          </dropdown-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import BaseButton from "@/components/UIComponents/Button"
import SelectStaffPopover from "@/components/BaseComponents/SelectStaffPopover"
import SelectEmojiPopper from "@/components/BaseComponents/SelectEmojiPopper"
import { deleteDiscussion, getDiscussionList, createDiscussion } from "@/api/sheet/sheet"
import { setFrontSetting, getFrontSetting } from "@/api/user"
import { sendTypes, operations } from "@/components/Sheet/DetailDialog/static"
import dj from "dayjs"
import PositionMixin from "@/components/Sheet/DetailDialog/PositionMixin"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "DataDiscuss",
  props: {
    dataId: String,
    appId: String,
    users: Array,
    userIdMap: Object,
    allSelectOptions: Array,
    fold: Boolean
  },
  components: {
    StaffAvatar,
    SelectStaffPopover,
    SelectEmojiPopper,
    BaseButton,
    StaffPopover,
    DropdownMenu
  },
  inject: ["detailDialog"],
  watch: {
    dataId: {
      handler() {
        this.init()
      },
      immediate: true
    },
    "detailDialog.visible": function(visible) {
      if (visible) this.init()
    },
    staffVisible: {
      handler(newVal) {
        if (newVal) {
          let obj = this.$el.querySelector("#textarea")
          let position = this.getInputPosition(obj)
          setTimeout(() => this.$refs.selectStaffPopper.changePosition(position))
        }
      },
      immediate: true
    }
  },
  mixins: [PositionMixin],
  data() {
    return {
      sendTypes,
      operations,
      discuss: {
        quote: {},
        quoteId: null,
        contentInfo: "",
        contentList: []
      },
      filterUsers: [],
      sendType: "Enter",
      staffVisible: false,
      emojiVisible: false,
      replaceIndex: {
        atPosition: null,
        number: null
      },
      discusses: [],
      style: {}
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo || {}
    },
    uniqueNamesMap() {
      let result = {}
      this.users.forEach(user => (result["@" + user.nameNew] = user))
      return result
    },
    discussList() {
      return this.discusses.map(discuss => {
        discuss.contentList.map(content => {
          if (content.type === "user") {
            content.name = this.userIdMap[content.id]?.nameNew
          }
          return content
        })
        discuss.quote?.contentList.map(content => {
          if (content.type === "user") {
            content.name = this.userIdMap[content.id]?.nameNew
          }
          return content
        })
        return discuss
      })
    }
  },
  methods: {
    init() {
      this.discuss = this.$options.data().discuss
      getDiscussionList(this.dataId).then(res => {
        this.discusses = res
        setTimeout(() => {
          if (this.discusses.length) {
            this.$refs.discuss[this.discusses.length - 1]?.scrollIntoView()
          }
        })
      })
      getFrontSetting(this.appId).then(res => {
        if (res?.discuss?.sendType) this.sendType = res.discuss.sendType
      })
    },
    changeVisible() {
      this.staffVisible = false
      this.emojiVisible = false
    },
    handleCommand(command, discuss) {
      switch (command) {
        case "delete":
          deleteDiscussion(discuss.id).then(() => {
            this.init()
            this.$message.success("删除成功")
          })
          break
        case "reply":
          this.reply(discuss)
      }
    },
    clearReply() {
      this.discuss.quoteId = ""
      this.discuss.quote = {}
    },
    reply(discuss) {
      discuss.name = discuss.sender.name
      this.discuss.quoteId = discuss.id
      this.discuss.quote = discuss
    },
    selectLook() {
      this.emojiVisible = true
    },
    setLook(look) {
      this.emojiVisible = false
      let index = this.getCursorPosition()
      if (this.discuss.contentInfo) {
        this.discuss.contentInfo =
          this.discuss.contentInfo.slice(0, index) + look + this.discuss.contentInfo.slice(index)
      } else {
        this.discuss.contentInfo = look
      }
      this.setCursorPosition(index + 2)
      this.getContent(this.discuss.contentInfo)
    },
    sendMessage() {
      this.discuss.appId = this.appId
      this.discuss.dataId = this.dataId
      this.discuss.senderId = this.curUser.userId
      this.discuss.time = dj(new Date()).format("YYYY-MM-DD HH:mm:ss")
      if (this.discuss.contentInfo.replace(/\s*/g, "")) {
        createDiscussion(this.discuss).then(() => {
          this.init()
          this.$message.success("发送成功")
          this.discuss = this.$options.data().discuss
        })
      }
    },
    handleSendCommand(command) {
      this.sendType = command
      setFrontSetting({ sendType: this.sendType }, this.appId, "discuss")
    },
    changeData(sendType) {
      this.sendType = sendType
    },
    getIndexes(content, uniqueName) {
      let result = []
      let index = content.indexOf(uniqueName)
      while (index !== -1) {
        result.push(index)
        index = content.indexOf(uniqueName, index + 1)
      }
      return result
    },
    getContent(content) {
      let result = []
      let count = 0
      this._.keys(this.uniqueNamesMap).forEach(uniqueName => {
        if (content.includes(uniqueName)) {
          count = count + 1
          let indexes = this.getIndexes(content, uniqueName)
          indexes.forEach(index =>
            result.push({
              type: "user",
              name: uniqueName,
              text: uniqueName,
              start: index,
              end: index + uniqueName.length,
              id: this.uniqueNamesMap[uniqueName].id
            })
          )
        }
      })
      let contents = []
      if (count === 0) {
        contents[0] = {
          type: "common",
          text: content
        }
      } else {
        let sortedResult = this._.sortBy(result, "start")
        sortedResult.forEach((item, index) => {
          if (index === 0) {
            if (item.start !== 0) {
              contents.push({
                type: "common",
                text: content.slice(0, item.start)
              })
            }
          } else {
            contents.push({
              type: "common",
              text: content.slice(sortedResult[index - 1].end, item.start)
            })
          }
          contents.push(item)
        })
        let end = sortedResult[sortedResult.length - 1].end
        contents.push({
          type: "common",
          text: content.slice(end)
        })
      }
      this.discuss.contentList = contents
    },
    showStaffPopover(content) {
      this.getContent(content)
      let index = this.getCursorPosition() - 1
      let Regx = /^[A-Za-z0-9]*$/
      if (!content) {
        this.filterUsers = []
        this.replaceIndex = { atPosition: null, number: null }
      }
      let atPosition = this.getNearest(content, index)
      if (atPosition === 0 || (atPosition !== undefined && !Regx.test(content[atPosition - 1]))) {
        this.replaceIndex = { atPosition: atPosition, number: index - atPosition + 1 }
        let filter = content.slice(atPosition + 1, index + 1)
        this.filterUsers = this.allSelectOptions.filter(user => user.nameNew.includes(filter))
      } else {
        this.filterUsers = []
        this.replaceIndex = { atPosition: null, number: null }
      }
      this.staffVisible = !!this.filterUsers.length
    },
    getNearest(content, index) {
      let atPositions = []
      for (let i = 0; i < content.length; i++) {
        if (content.charAt(i) === "@") {
          atPositions.push(i)
        }
      }
      let dis = []
      for (let atPosition of atPositions) {
        if (index >= atPosition) {
          dis.push(atPosition)
        }
      }
      return dis[dis.length - 1]
    },
    changeStr(str, index, number, changeStr) {
      return str.slice(0, index) + changeStr + str.slice(index + number)
    },
    liftUser(user) {
      this.staffVisible = false
      let changeStr = ""
      if (user.id === "team") {
        user.teamList.forEach(u => (changeStr = changeStr + "@" + u.nameNew + " "))
      } else {
        changeStr = "@" + user.nameNew + " "
      }
      this.discuss.contentInfo = this.changeStr(
        this.discuss.contentInfo,
        this.replaceIndex.atPosition,
        this.replaceIndex.number,
        changeStr
      )
      let position = this.replaceIndex.atPosition + changeStr.length
      this.setCursorPosition(position)
      this.getContent(this.discuss.contentInfo)
    },
    getCursorPosition() {
      let obj = this.$el.querySelector("#textarea")
      let cursorIndex = 0
      if (document.selection) {
        // IE
        obj.focus()
        let range = document.selection.createRange()
        range.moveStart("character", -obj.value.length)
        cursorIndex = range.text.length
      } else if (obj.selectionStart || obj.selectionStart === 0) {
        // 非IE
        cursorIndex = obj.selectionStart
      }
      return cursorIndex
    },
    setCursorPosition(pos) {
      let obj = this.$el.querySelector("#textarea")
      if (obj.setSelectionRange) {
        // 非IE
        obj.focus()
        this.$nextTick(() => obj.setSelectionRange(pos, pos))
      } else if (obj.createTextRange) {
        // IE
        let range = obj.createTextRange()
        range.collapse(true)
        range.moveEnd("character", pos)
        range.moveStart("character", pos)
        range.select()
      }
    },
    focus() {
      document.onkeydown = e => {
        let keyCode = e.keyCode || e.which || e.charCode
        let ctrlKey = e.ctrlKey
        switch (this.sendType) {
          case "Enter":
            if (keyCode === 13) {
              this.sendMessage()
            }
            break
          case "Enter+Ctrl":
            if (ctrlKey && keyCode === 13) {
              this.sendMessage()
            }
            break
        }
      }
    },
    blur() {
      this.$emit("blur")
    },
    setFocus() {
      let obj = this.$el.querySelector("#textarea")
      obj.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.data-discuss {
  display: flex;
  flex-flow: column;
  overflow: hidden;
  height: 100%;
  .discuss-list {
    overflow: hidden;
    flex: 1;
    padding-top: 10px;
    .discuss-content {
      &:hover {
        .operation {
          display: block;
        }
      }
      .operation {
        display: none;
      }
      display: flex;
      padding: 0 10px 10px 13px;
      .member-avatar {
        .avatar {
          flex-shrink: 0;
        }
      }
      .message-content {
        margin-top: 2px;
        margin-left: 8px;
        width: 100%;
        .basic-info {
          display: flex;
          justify-content: space-between;
          .sender-name {
            margin-right: 8px;
            color: #303133;
            font-size: 13px;
          }
          .time {
            color: #878a90;
            font-size: 10px;
          }
        }
        .message-main {
          margin: 4px 0 10px;
          display: flex;
          flex-flow: column;
          .other {
            background-color: #e7eaee;
            border-radius: 4px;
            padding: 4px;
            margin-bottom: 4px;
            .other-name {
              color: #313132;
              font-size: 12px;
            }
            .other-message {
              font-size: 12px;
            }
          }
          .message {
            color: #303133;
            font-size: 13px;
          }
        }
      }
    }
  }
  .reply-area {
    height: 120px;
    border-top: 1px solid #e4e7ed;
    display: flex;
    justify-content: space-between;
    flex-flow: column;
    .message-area {
      flex: 1;
      .other {
        padding: 5px 0;
        margin: 0 15px;
        color: #878a90;
        font-size: 12px;
        position: relative;
        border-bottom: 1px dashed #c0c4cc;
        .clear-reply {
          position: absolute;
          right: -10px;
          height: 100%;
          top: 0;
          display: flex;
          align-items: center;
        }
        ::v-deep {
          .el-divider--vertical {
            margin: 0 4px 0 0;
          }
        }
      }
      ::v-deep {
        .el-textarea__inner {
          background-color: unset;
          border: unset;
          font-size: 13px;
          color: #303133;
        }
      }
    }
    .operation-area {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 10px;
      height: 35px;
      .send-type {
        display: flex;
        align-items: center;
        .base-button {
          font-size: 13px;
        }
      }
    }
  }
  .icon-color {
    color: #878a90;
  }
}
</style>
